import { render, staticRenderFns } from "./Home.global-offers-scraper.vue?vue&type=template&id=9b05cd26&scoped=true&"
import script from "./Home.global-offers-scraper.vue?vue&type=script&lang=js&"
export * from "./Home.global-offers-scraper.vue?vue&type=script&lang=js&"
import style0 from "./Home.global-offers-scraper.vue?vue&type=style&index=0&id=9b05cd26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b05cd26",
  null
  
)

export default component.exports